/**
 * Scroll Animate
 * 当元素进入窗口内时，为其添加一个类选择器，以实现随页面滚动做动画的效果
 * 相关样式属性在 scroll-anim.scss 中定义
 * 为要做动画的元素添加属性 data-anim="ClassName"
 * 则该 ClassName 将作为类选择器添加到该元素上
 */

import './scroll-anim.scss';

class ScrollAnim {
    constructor() {
        this.scrollTop = 0;
        this.lastTime = 0;
        this.animElem = $('[data-anim]').data({ animStatus: false });
        this.stampElem = $('[data-stamp]').data({ animStatus: false });
        $(document).scroll(this._handleScroll.bind(this));
        this._handleScroll();
    }

    _handleScroll() {
        if (Date.now() - this.lastTime > 16) {
            this.lastTime = Date.now();
            this.scrollTop = $(document).scrollTop();
            this.animElem.each((index, elem) => {
                const $elem = $(elem);
                if (
                    this.scrollTop >=
                        $elem.offset().top - $(window).outerHeight() &&
                    !$elem.data('animStatus')
                ) {
                    $elem.data({ animStatus: true }).css({
                        animation: $elem.data('anim'),
                    });
                }
            });

            this.stampElem.each((index, elem) => {
                const $elem = $(elem);
                if (
                    this.scrollTop >=
                        $elem.offset().top +
                            $elem.outerHeight() -
                            $(window).outerHeight() &&
                    !$elem.data('animStatus')
                ) {
                    $elem
                        .data({ animStatus: true })
                        .addClass($elem.data('stamp'));
                }
            });
        }
    }
}

export default ScrollAnim;
